import javascript from "../assets/Tech/javascript.png";
import html from "../assets/Tech/html.png";
import css from "../assets/Tech/css.png";
import reactjs from "../assets/Tech/reactjs.png";
import tailwind from "../assets/Tech/tailwind.png";
import nodejs from "../assets/Tech/nodejs.png";
import git from "../assets/Tech/git.png";
import figma from "../assets/Tech/figma.png";
import docker from "../assets/Tech/docker.png";
import redux from "../assets/Tech/redux.png";
import typescript from "../assets/Tech/typescript.png";
import java from "../assets/Tech/java.png";
import ReactQuery from "../assets/Tech/react-query.png";

const Frontend = [
  {
    name: "HTML 5",
    icon: html,
  },
  {
    name: "CSS 3",
    icon: css,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "Bootstrap",
    icon: "https://img.icons8.com/color/480/000000/bootstrap.png",
  },
  {
    name: "Next js",
    icon: "https://img.icons8.com/color/480/000000/nextjs.png",
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Redux",
    icon: redux,
  },
  {
    name: "Typescript",
    icon: typescript,
  },
  {
    name: "React Query",
    icon: ReactQuery,
  },
];
const Design = [
  {
    name: "Figma",
    icon: figma,
  },
];
const Backend = [
  {
    name: "Node JS",
    icon: nodejs,
  },

  {
    name: "MySql",
    icon: "https://img.icons8.com/color/480/000000/mysql-logo.png",
  },
  {
    name: "java",
    icon: java,
  },
  {
    name: "Firebase",
    icon: "https://img.icons8.com/color/480/000000/firebase.png",
  },
];
const technologies = [
  {
    name: "Google Cloud",
    icon: "https://img.icons8.com/color/480/000000/google-cloud.png",
  },
  {
    name: "gitlab",
    icon: "https://img.icons8.com/color/480/000000/gitlab.png",
  },
  {
    name: "github",
    icon: "https://img.icons8.com/color/480/000000/github.png",
  },
  {
    name: "git",
    icon: git,
  },
  {
    name: "Jira",
    icon: "https://img.icons8.com/color/480/000000/jira.png",
  },

  {
    name: "docker",
    icon: docker,
  },
  {
    name: "flutter",
    icon: "https://img.icons8.com/color/480/000000/flutter.png",
  },
];

export { technologies, Frontend, Backend, Design };
